<template>
  <div>
    <!-- Has Actions -->
    <div v-if="hasActions">
      <div class="columns">
        <!-- Actions -->
        <div class="column is-one-quarter" v-for="(action, index) in actions" :key="index">
          <b-button v-if="action.type === 'primary'" type="is-primary" outlined expanded size="is-medium" @click="$emit(action.event)">{{ action.label }}</b-button>
          <b-button v-else type="is-light" expanded size="is-medium" @click="$emit(action.event)">{{ action.label }}</b-button>
        </div>
        <div v-if="moreActions && moreActions.length" class="column is-one-quarter">
          <b-dropdown expanded>
            <b-button expanded slot="trigger" size="is-medium">
                <b-icon icon="dots-vertical"></b-icon>
                <span>More</span>
              </b-button>
            <b-dropdown-item has-link v-for="(action, index) in moreActions" :key="index">
              <a href="#" @click.prevent="$emit(action.event)">
                {{ action.label }}
              </a>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <!-- Has No Actions -->
    <div v-else>
      <div class="columns">
        <div class="column"><b-button :disabled="true" >No Actions</b-button></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['context']),
    hasActions () {
      return (this.actions.length > 0 || this.additionalActions.length > 0)
    },
    actions () {
      const actions = []
      // proposed can be approved or returned
      if (this.proposal.status === 'proposed') {
        actions.push({ label: 'Approve Products', event: 'action:approve', type: 'primary' })
        actions.push({ label: 'Return', event: 'action:revise', type: 'secondary' })
      }
      // approved can be approved or returned
      if (this.proposal.status === 'approved') {
        if ('require_pricing_approval_on_proposals' in this.proposal.connection.options) {
          actions.push({ label: 'Approve Pricing', event: 'action:pricing', type: 'primary' })
        } else {
          actions.push({ label: 'Complete', event: 'action:complete', type: 'secondary' })
        }
      }
      // pricing approved can be completed
      if (this.proposal.status === 'pricing_approved') {
        actions.push({ label: 'Complete', event: 'action:complete', type: 'secondary' })
      }
      // completed proposals can be published (and acknowledged)
      if (this.proposal.status === 'completed') {
        // actions.push({ label: 'Publish', event: 'action:publish', type: 'secondary' })
        if (this.proposal.acknowledged_at === null) {
          actions.push({ label: 'Mark as Complete!', event: 'action:acknowledge', type: 'secondary' })
        }
      }
      // all proposals can be exported
      actions.push({ label: 'Export', event: 'action:export', type: 'secondary' })
      return actions
    },
    moreActions () {
      const moreActions = []
      const { status, connection } = this.proposal
      // all proposals (except completed) can be reassigned...
      if (status !== 'completed') {
        moreActions.push({ label: 'Change Owner', event: 'action:owner' })
      }
      // not showing on proposed status
      const list = ['proposed', 'pricing_approved']
      if (list.includes(status) || (status === 'approved' && 'require_pricing_approval_on_proposals' in connection.options)) {
        moreActions.push({ label: 'Apply Transformers', event: 'action:applyTransformer' })
      }
      // allow decline of 'proposed' proposals
      if (status === 'proposed') {
        moreActions.push({ label: 'Decline Proposal', event: 'action:decline' })
      }
      return moreActions
    }
  },
  props: {
    proposal: {
      type: Object,
      required: true
    }
  }
}
</script>
